// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowFeeTypeActionsMenu = ({ row, onEdit, onDelete, hasPermission }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.status == "INACTIVE";
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit(row);
              handleClose();
            }}
          >
            Edit FeeType
          </MenuItem>
        )}
        {hasPermission("delete") && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onDelete(row.fee_type_id, row.fee_category_id);
              handleClose();
            }}
          >
            Delete FeeType
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
RowFeeTypeActionsMenu.propTypes = {
  row: PropTypes.shape({
    fee_type_id: PropTypes.number.isRequired,
    fee_type_name: PropTypes.string.isRequired,
    fee_category_id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};
export default RowFeeTypeActionsMenu;
